"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTable = _interopRequireDefault(require("react-table"));
var _selectTable = _interopRequireDefault(require("react-table/lib/hoc/selectTable"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RcReactTablePaginationManager = _interopRequireDefault(require("./RcReactTablePaginationManager"));
var _RcReactTableLoading = _interopRequireDefault(require("./RcReactTableLoading"));
var _RcReactTableNoData = _interopRequireDefault(require("./RcReactTableNoData"));
var _RcReactTableSelectInput = _interopRequireDefault(require("./RcReactTableSelectInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-underscore-dangle */
class RcReactTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "assignRef", element => {
      this.tableElement = element;
    });
    _defineProperty(this, "toggleSelection", (key, shift, row) => {
      let selection = [...this.state.selection];
      const keyIndex = selection.indexOf(key);
      let isToggleOn = false;
      if (keyIndex >= 0) {
        selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)];
      } else {
        selection.push(key);
        isToggleOn = true;
      }
      this.setState({
        selection
      }, () => this.props.onToggle(row, isToggleOn));
    });
    // eslint-disable-next-line no-unused-vars
    _defineProperty(this, "getPaginationProps", (state, rowInfo, column, instance) => {
      const {
        selectTable
      } = this.props;
      let selected = null;
      if (selectTable) {
        selected = this.state?.selection ? this.state.selection.length : 0;
      }
      return {
        ...state,
        selected
      };
    });
    // getPaginationProps = (state, rowInfo, column, instance) => {
    //   console.log(state);
    //   return {
    //      ...state,
    //      selected: this.state?.selection ? this.state.selection.length : 0,
    //    }}
    _defineProperty(this, "toggleAll", () => {
      const {
        keyField
      } = this.props;
      const selectAll = !this.state.selectAll;
      const selection = [];
      if (selectAll && this.getSortedData()) {
        const currentRecords = this.getSortedData();
        currentRecords.forEach(item => {
          selection.push(`select-${item._original[keyField]}`);
        });
      }
      this.setState({
        selectAll,
        selection
      }, () => this.props.onToggle());
    });
    _defineProperty(this, "isSelected", key => this.state.selection.includes(`select-${key}`));
    _defineProperty(this, "rowFn", (state, rowInfo) => {
      const {
        selection
      } = this.state;
      const {
        keyField
      } = this.props;
      return {
        onClick: (e, handleOriginal) => {
          if (handleOriginal) {
            handleOriginal();
          }
        },
        className: rowInfo && rowInfo.original && selection.includes(`select-${rowInfo.original[keyField]}`) && 'is-selected'
      };
    });
    this.tableReference = /*#__PURE__*/_react.default.createRef();
    this.state = {
      selectAll: false,
      selection: []
    };
    this.isSelected = this.isSelected.bind(this);
    this.getSelections = this.getSelections.bind(this);
  }
  componentDidMount() {
    if (this.props.checkWidth) {
      this.match = window.matchMedia('(max-width: 768px)');
      this.checkWidth = e => {
        if (e.matches) {
          const allTh = this.tableElement.getElementsByTagName('th');
          for (let n = 0; n < allTh.length; n += 1) {
            allTh[n].style = '';
          }
          const allTd = this.tableElement.getElementsByTagName('td');
          for (let n = 0; n < allTd.length; n += 1) {
            allTd[n].style = '';
          }
        }
      };
      this.checkWidth(this.match);
      this.match.addListener(this.checkWidth);
    }
  }
  componentDidUpdate() {
    this.componentDidMount();
  }
  componentWillUnmount() {
    if (this.props.checkWidth) {
      this.match.removeListener(this.checkWidth);
    }
  }
  getResolvedState() {
    const table = this.tableReference.current;
    return table == null || table.getWrappedInstance() ? null : table.getWrappedInstance().getResolvedState();
  }
  getSortedData() {
    const table = this.tableReference.current;
    if (table && table.getWrappedInstance() && table.getWrappedInstance().getResolvedState()) {
      const tableState = table.getWrappedInstance().getResolvedState();
      return tableState == null ? null : tableState.sortedData;
    }
    return null;
  }
  getSelections() {
    const {
      keyField
    } = this.props;
    const table = this.tableReference.current;
    if (table && table.getWrappedInstance() && table.getWrappedInstance().getResolvedState()) {
      const tableState = table.getWrappedInstance().getResolvedState();
      return !tableState || !tableState.sortedData ? null : tableState.sortedData.filter(item => this.isSelected(item._original[keyField])).map(filteredItem => filteredItem._original);
    }
    return null;
  }
  getFilter(column) {
    const table = this.tableReference.current;
    if (table && table.getWrappedInstance() && table.getWrappedInstance().getResolvedState()) {
      const tableState = table.getWrappedInstance().getResolvedState();
      return tableState.filtered.find(filter => filter.id === column.id);
    }
    return undefined;
  }
  filterColumn(column, value) {
    const table = this.tableReference.current;
    table.filterColumn(column, value);
  }
  render() {
    const {
      loading,
      noRowsText,
      isError,
      selectTable,
      keyField,
      getTrProps,
      getTdProps,
      getTheadTrProps,
      getTheadThProps,
      getTfootTrProps,
      getTfootTdProps,
      className: tableClassName
    } = this.props;
    const Table = selectTable ? (0, _selectTable.default)(_reactTable.default) : _reactTable.default;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Table, _extends({
      ref: this.tableReference,
      TableComponent: _ref => {
        let {
          children,
          className,
          ...rest
        } = _ref;
        return /*#__PURE__*/_react.default.createElement("table", _extends({
          className: `table${tableClassName ? ` ${tableClassName}` : ''}`
        }, rest, {
          ref: this.assignRef
        }), children);
      },
      TheadComponent: _ref2 => {
        let {
          children,
          className,
          ...rest
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement("thead", _extends({
          className: className
        }, rest), children);
      },
      TbodyComponent: _ref3 => {
        let {
          children,
          className,
          ...rest
        } = _ref3;
        return /*#__PURE__*/_react.default.createElement("tbody", _extends({
          className: className
        }, rest), children);
      },
      TfootComponent: _ref4 => {
        let {
          children,
          className,
          ...rest
        } = _ref4;
        return /*#__PURE__*/_react.default.createElement("tfoot", _extends({
          className: className
        }, rest), children);
      },
      TrComponent: _ref5 => {
        let {
          children,
          className,
          ...rest
        } = _ref5;
        return /*#__PURE__*/_react.default.createElement("tr", _extends({
          className: className
        }, rest), children);
      },
      TdComponent: _ref6 => {
        let {
          toggleSort,
          children,
          className,
          ...rest
        } = _ref6;
        return /*#__PURE__*/_react.default.createElement("td", _extends({}, rest, {
          className: className
        }), children);
      },
      ThComponent: _ref7 => {
        let {
          toggleSort,
          className,
          children,
          ...rest
        } = _ref7;
        return /*#__PURE__*/_react.default.createElement("th", _extends({
          className: className,
          onClick: e => toggleSort && toggleSort(e),
          tabIndex: "-1"
        }, rest), /*#__PURE__*/_react.default.createElement("div", {
          className: "table-header--wrapper"
        }, children));
      },
      TrGroupComponent: _ref8 => {
        let {
          children
        } = _ref8;
        return children;
      },
      loadingText: ""
      // style={{
      //   overflow: 'auto',
      // }}
      ,
      getPaginationProps: this.getPaginationProps,
      PaginationComponent: _RcReactTablePaginationManager.default,
      LoadingComponent: isError ? null : _RcReactTableLoading.default,
      noDataText: !loading ? noRowsText : '',
      NoDataComponent: _RcReactTableNoData.default,
      toggleSelection: this.toggleSelection,
      selectAll: this.state.selectAll,
      selectType: "checkbox",
      toggleAll: this.toggleAll,
      isSelected: this.isSelected,
      getTrProps: getTrProps || this.rowFn,
      getTdProps: getTdProps,
      getTheadTrProps: getTheadTrProps,
      getTheadThProps: getTheadThProps,
      getTfootTrProps: getTfootTrProps,
      getTfootTdProps: getTfootTdProps,
      keyField: keyField,
      SelectInputComponent: _RcReactTableSelectInput.default,
      SelectAllInputComponent: _RcReactTableSelectInput.default
    }, this.props)));
  }
}
RcReactTable.propTypes = {
  loading: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  selectTable: _propTypes.default.bool,
  noRowsText: _propTypes.default.string,
  keyField: _propTypes.default.string,
  onToggle: _propTypes.default.func,
  getTrProps: _propTypes.default.func,
  getTdProps: _propTypes.default.func,
  getTheadTrProps: _propTypes.default.func,
  getTheadThProps: _propTypes.default.func,
  getTfootTrProps: _propTypes.default.func,
  getTfootTdProps: _propTypes.default.func,
  checkWidth: _propTypes.default.bool,
  className: _propTypes.default.string
};
RcReactTable.defaultProps = {
  loading: false,
  isError: false,
  selectTable: false,
  checkWidth: true,
  noRowsText: 'No rows found',
  keyField: 'id',
  onToggle: () => {},
  className: 'is-fullwidth'
};
var _default = exports.default = RcReactTable;
//# sourceMappingURL=RcReactTable.js.map